<mat-expansion-panel
    class="experiment"
    [expanded]="expand()"
    (opened)="expand.set(true)"
    (closed)="expand.set(false)"
    (keydown.space)="$event.stopPropagation()"
    [style]="{boxShadow: 'none'}"
>
    <mat-expansion-panel-header>
        <mat-panel-title>
            <form [formGroup]="form" style="width: 100%">
                @if (expand()) {
                    <mat-form-field style="width: 100%">
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput
                               (click)="onFocus($event)"
                               (keydown.space)="$event.stopPropagation()"
                               [formControlName]="'search'"
                               [placeholder]="placeholder"
                               width="100%">
                    </mat-form-field>
                } @else {
                    @if (currentItem()) {
                        <ng-container
                            *ngTemplateOutlet="itemView || defaultView; context: {$implicit:currentItem()}"></ng-container>
                        <ng-template #defaultView let-item="$implicit">
                            <h1>itemView from component</h1>
                            {{ item  | json }}
                        </ng-template>
                    } @else {
                      <span class="placeholder">{{placeholder}}</span>
                    }
                }
            </form>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <ol class="list">
        @for (i of filtredItems$ | async; track i) {
            <li class="list-item" (click)="currentItem.set(i)">
                <ng-container *ngTemplateOutlet="itemView||defaultView; context: {$implicit:i, active: equalCurrentItem(i)}"></ng-container>
                <ng-template #defaultView let-item>
                    {{ item | json }}
                </ng-template>
            </li>
        }
    </ol>
</mat-expansion-panel>
